<template>
    <BorrarModalComponent
        :name="'borrar-sesion-' + sesion.id"
        title="¿Seguro que quieres borrar esta sesion?"
        borrarTitle="Datos de la sesión"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarSesion()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Fecha:</b> {{ fechaFormateada }}
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>

    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";
    import { formatSesionFecha } from '@/utils/dateUtils';

    export default {
        props: ['evento', 'sesion'],
        computed: {
            // La sesión viene del listado v2: `start_at` es un instante ISO 8601.
            fechaFormateada() {
                return formatSesionFecha(this.sesion.start_at);
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-sesion-' + this.sesion.id, borrado);
            },
            borrarSesion() {
                const params = {
                    filters : {},
                    evento_id: this.evento.id,
                    sesion_id: this.sesion.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message || 'No se pudo borrar la sesión');
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
